import dayjs from "dayjs";
import * as yup from "yup";

export const CREATE_SOURCE_VALUES_INITIAL_VALUES = {
  valueName: "",
  valueDescription: "",
  startDate: dayjs(new Date()).format("YYYY-MM-DD"),
  endDate: dayjs(new Date()).format("YYYY-MM-DD"),
};

export const CREATE_SOURCE_VALUES_VALIDATION_SCHEMA = {
  valueName: yup
    .string()
    .trim()
    .required("Reference Source Value Name is a required field."),
  valueDescription: yup.string().trim(),
  startDate: yup.date().required("Start Date is a required field"),
  endDate: yup
    .date()
    .required("End Date is a required field")
    .min(yup.ref("startDate"), "Start Date must be before End Date"),
};
